


















import { editFactory } from '@/main/pages';

import { components } from '../../components';
import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';


export default editFactory(NAME, store).extend({
	components: {
		PpNrSelect: components.PpNrSelect,
	},
	computed: {
		mutationsMappers() {
			return {
				ppNr: `${this.storeUri}/${editMutations.PRACOVNI_POZICE_PPNR_SELECT_MAPPER}`,
			};
		},
	},
});
